import { SortOption } from '@/components/derived/FlexTable/FlexTable.component'

export const SortOptions = {
  mentions: [
    { key: 'date', label: 'Data da menção' },
    { key: 'potentialReach', label: 'Alcance potencial' },
    { key: 'likes', label: 'Número de curtidas' },
    { key: 'comments', label: 'Número de comentários' },
    { key: 'shares', label: 'Número de compartilhamentos' },
    { key: 'views', label: 'Número de visualizações' },
    { key: 'reactions', label: 'Número de reações' },
    { key: 'followers', label: 'Número de seguidores' },
    { key: 'tier', label: 'Tier' },
    { key: 'totalInteractions', label: 'Total de interações' },
  ] as SortOption[],
} as const

export const createSortOptions = (fields: Array<{ key: string; label: string }>): SortOption[] => {
  return fields.map((field) => ({ key: field.key, label: field.label }))
}
